import cloneDeep from 'lodash/cloneDeep'
import { ModerationBoundaryView } from '../../api/client'
import { ModerationBoundaryTemplate } from '../../models/Moderation'
import ModerationBoundaryRow from './ModerationBoundaryRow'

type Props = {
    boundaries: ModerationBoundaryView[]
    setSelectedBoundary: (boundary: ModerationBoundaryView) => void
    setEditOpen: (open: boolean) => void
    showCompare: boolean
    compareWith: Map<string, ModerationBoundaryTemplate>
    compareName: string
    onDelete: (moderationBoundaryView: ModerationBoundaryView) => void
    /** Classifier ids whose boundaries are owned by classifier deployment. */
    promptManagedClassifierIds: Set<number>
}

const headerCell = 'px-3 py-2 text-left text-xs font-medium uppercase tracking-wide text-gray-700'

function ModerationBoundaryList(props: Props) {
    const {
        boundaries,
        setSelectedBoundary,
        setEditOpen,
        showCompare,
        compareWith,
        compareName,
        onDelete,
        promptManagedClassifierIds
    } = props

    return (
        <div className="overflow-x-auto rounded-lg border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className={headerCell}>
                            Classifier
                        </th>
                        <th scope="col" className={`${headerCell} text-right`}>
                            Probability
                        </th>
                        {showCompare && (
                            <th scope="col" className={`${headerCell} text-right`}>
                                {compareName}
                            </th>
                        )}
                        <th scope="col" className="px-3 py-2">
                            <span className="sr-only">Actions</span>
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 bg-white">
                    {boundaries.length === 0 && (
                        <tr>
                            <td
                                colSpan={showCompare ? 4 : 3}
                                className="px-3 py-6 text-center text-sm text-gray-600"
                            >
                                No classifiers in this queue yet.
                            </td>
                        </tr>
                    )}
                    {boundaries.map((boundary) => {
                        const matchingBoundaryTemplate = compareWith.get(
                            boundary.classifier.shortName.toLowerCase()
                        )

                        return (
                            <ModerationBoundaryRow
                                key={boundary.classifier.id}
                                boundary={boundary}
                                onEditClick={() => {
                                    setSelectedBoundary(cloneDeep(boundary))
                                    setEditOpen(true)
                                }}
                                showCompare={showCompare}
                                compareWith={matchingBoundaryTemplate}
                                onDelete={onDelete}
                                promptManaged={promptManagedClassifierIds.has(
                                    boundary.classifier.id
                                )}
                            />
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default ModerationBoundaryList
